<template>
  <div class="box">
    <div class="box-header">Overview</div>
    <div class="box-body">
      <div class="row">
        <div class="col-3">All Chart <h3>{{ data['all_charts'] }}</h3></div>
        <div class="col-3">Named Charts</div>
        <div class="col-3"></div>
        <div class="col-3"></div>
      </div>
    </div>
    <div class="box-footer"></div>
  </div>
</template>
  
<script>


export default {
  name: 'Overview',
  props: ['data']
}
</script>

  